import { Pipe, PipeTransform } from '@angular/core';
import { DataFormatService } from 'src/app/core/services/data-format.service';

@Pipe({
  name: 'currencyFormat'
})
export class CurrencyFormatPipe implements PipeTransform {

  transform(value: any, ...args: any): any {
    const dataFormat = new DataFormatService();
    if (args[0] !== '') {
      return dataFormat.formatMoneyNoSymbol(value, args[0]);
    }
    return value;
  }

}
